//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetOrderStatusList = () =>
    request({
        url: ApiURL.Query.GetOrderStatusList,
        method: RequestType.GET,
        //params:params,
    });
const GetSellerNameList = () =>
    request({
        url: ApiURL.Query.GetSellerNameListAll,
        method: RequestType.GET,
        //params:params,
    });
const GetOrderActionRules = () =>
    request({
        url: ApiURL.Query.GetOrderActionRules,
        method: RequestType.GET,
        //params:params,
    });
const GetShippingListPackageDetail = (params: any) =>
    request({
        url: ApiURL.Query.GetShippingListPackageDetail,
        method: RequestType.GET,
        params: params,
    });
const GetUserSaleOrderStatusHistory = (params: any) =>
    request({
        url: ApiURL.Query.GetUserSaleOrderStatusHistory,
        method: RequestType.GET,
        params: params,
    });
const GetShippingListCancelReason = () =>
    request({
        url: ApiURL.Query.GetShippingListCancelReason,
        method: RequestType.GET,
    });
const GetOrderIdFromDigitalCardNo = (data: any) =>
    request({
        url: ApiURL.Query.GetOrderIdFromDigitalCardNo,
        method: RequestType.POST,
        data: data,
    });
const GetOrderShipmentStatus = () =>
    request({
        url: ApiURL.Query.GetOrderShipmentStatus,
        method: RequestType.GET,
    });
const GetOrderCancelReason = () =>
    request({
        url: ApiURL.Query.GetOrderCancelReason,
        method: RequestType.GET,
    });
const GetShippingListByRole = (data: any) => {
    const toStatusQuery = data.toStatus.map((status: any) => `ToStatus=${status}`).join('&');
    const url = `${ApiURL.Query.GetShippingListByRole}?FromStatus=${data.fromStatus}&${toStatusQuery}`;
    return request({
        url,
        method: RequestType.GET,
    });
};
const GetOrderShipmentStatusForStatusChange = (data: any, signal?: AbortSignal) => {
    let url = ApiURL.Query.GetOrderShipmentStatusForStatusChange;
    if (data) {
        url += `?FromStatusId=${data.fromStatusId}&IsSellerStore=${data.isSellerStore}&userRef=${data.userRef}&shipmentId=${data.shipmentId}&customerId=${data.customerId}`;
    }
    return request({
        url: url,
        method: RequestType.GET,
        signal,
    });
};
const VerifyOtp = (data: any) =>
    request({
        url:
            ApiURL.Query.VerifyOtp +
            '?shippingListId=' +
            data.shippingListId +
            '&VerificationCode=' +
            data.verificationCode,
        method: RequestType.GET,
    });
const ResendOtp = (data: any) =>
    request({
        url: ApiURL.Query.ResendOtp,
        method: RequestType.POST,
        data: data,
    });
//get-shipping-statuses-from-rule-service-by-shipment-id

const GetShippingStatusesFromRuleServiceByShipmentId = (params: any) =>
    request({
        url: `${ApiURL.Query.GetShippingStatusesFromRuleServiceByShipmentId}?shipmentId=${params.shipmentId}&cultureCode=${params.cultureCode}`,
        method: RequestType.GET,
    });
const GetShipmentStatusList = (params: any) =>
    request({
        url: `${ApiURL.Query.GetShipmentStatusList}?cultureCode=${params.cultureCode}`,
        method: RequestType.GET,
    });

const CheckOtpAvailability = (params: { countryId: number }) =>
    request({
        url: `${ApiURL.Query.CheckOtpAvailability}?countryId=${params.countryId}`,
        method: RequestType.GET,
    });

const CheckCancelShipmentCallCenterRole = () =>
    request({
        url: ApiURL.Query.CheckCancelShipmentCallCenterRole,
        method: RequestType.GET,
    });

const GetReshippingActionButtonRule = () =>
    request({
        url: ApiURL.Query.GetReshippingActionButtonRule,
        method: RequestType.GET,
    });

const SearchOrdersByIdentifiers = (data: { SearchIdentifiers: string }) =>
    request({
        url: ApiURL.Query.SearchOrdersByIdentifiers,
        method: RequestType.POST,
        data,
    });

const OrderQuery = {
    GetOrderStatusList,
    GetSellerNameList,
    GetOrderActionRules,
    GetShippingListPackageDetail,
    GetUserSaleOrderStatusHistory,
    GetShippingListCancelReason,
    GetOrderIdFromDigitalCardNo,
    GetOrderShipmentStatus,
    GetOrderCancelReason,
    GetShippingListByRole,
    GetOrderShipmentStatusForStatusChange,
    VerifyOtp,
    ResendOtp,
    GetShippingStatusesFromRuleServiceByShipmentId,
    GetShipmentStatusList,
    CheckOtpAvailability,
    CheckCancelShipmentCallCenterRole,
    GetReshippingActionButtonRule,
    SearchOrdersByIdentifiers,
};

export default OrderQuery;
